module.exports = __webpack_public_path__ + "img/2.6d47d6a6.png";